window.$ = window.jQuery = require('jquery');
window.inputmask = require('inputmask/dist/jquery.inputmask.min').default;

require('magnific-popup');
require('slick-carousel');

$(window).on('load', function () {

    window.setTimeout(function () {
        $('.load').animate({
            opacity: 0
        }, 500, function () {
            $(this).hide();
        })
    }, 250);

});

$(document).ready(function () {

    $('.form-booking').submit(function (e) {
        e.preventDefault();

        var form = $(this);

        $.ajax({
            headers: {
                'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
            },
            type: 'POST',
            url: form.attr('action'),
            data: form.serialize(),
            dataType: 'json',
            success: function (data, textStatus, jqXHR) {

                var responce = $.parseJSON(jqXHR.responseText);

                $('.form__input').removeClass('form__input--error').val('');
                $('.form__checkbox').removeClass('form__input--error');
                $('.form__textarea').val('');
                $('.form__submit').val('Форма отправлена').addClass('form__submit--success');

                ym(74419810,'reachGoal','booking')
            },
            error: function (err) {

                form.find('input').removeClass('form__input--error');

                $.each(err.responseJSON.errors, function (i, error) {
                    form.find('input[name="' + i + '"]').addClass('form__input--error');
                });

            }
        });
    });

    $('.form-write').submit(function (e) {
        e.preventDefault();

        var form = $(this);

        $.ajax({
            headers: {
                'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
            },
            type: 'POST',
            url: form.attr('action'),
            data: form.serialize(),
            dataType: 'json',
            success: function (data, textStatus, jqXHR) {

                var responce = $.parseJSON(jqXHR.responseText);

                $('.form__input').removeClass('form__input--error').val('');
                $('.form__checkbox').removeClass('form__input--error');
                $('.form__textarea').val('');
                $('.form__submit').val('Форма отправлена').addClass('form__submit--success');

                ym(74419810,'reachGoal','write')
            },
            error: function (err) {

                form.find('input').removeClass('form__input--error');

                $.each(err.responseJSON.errors, function (i, error) {
                    form.find('input[name="' + i + '"]').addClass('form__input--error');
                });

            }
        });
    });

    $('.sweet__gallery').slick({
        dots: true,
        arrows: false,
    });

    $('.image-popup-vertical-fit').magnificPopup({
        type: 'image',
        closeOnContentClick: true,
        mainClass: 'mfp-img-mobile',
        image: {
            verticalFit: true
        }

    });

    Inputmask("+7 (999) 999-99-99").mask('.phone-mask');

    function hideBody() {
        $('html, body').css('overflow', 'hidden');
    }

    function clearBodyStyle() {
        $('html, body').removeAttr('style');
    }

    function openModal(modal){
        $('.modal').filter('[data-modal='+modal+']').show();
    }

    function closeModal(){
        $('.modal').hide();
    }

    $(document).on('click', '.hamburger', function (e) {
        e.preventDefault();
        hideBody();
        openModal('modal-menu')
    });

    $(document).on('click', '.btn-order', function (e) {
        e.preventDefault();
        hideBody();
        openModal('modal-order')
    });

    $(document).on('click', '.write_us', function (e) {
        e.preventDefault();
        hideBody();
        openModal('modal-write')
    });

    $(document).on('click', '.modal__close', function (e) {
        e.preventDefault();
        clearBodyStyle();
        closeModal();
    });


});
